import { httpRequest } from "@services/http";
import { MemberJourneyMap } from "@models/journeyMap.model";

export class CommandGetMemberJourneyMap {
  async run(audienceId: number, memberId: number): Promise<MemberJourneyMap> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/audiences/${audienceId}/members/${memberId}/journey-map/`;
    return await httpRequest<MemberJourneyMap>(url, { method: "GET", cache: "no-store" });
  }
}
